import OktaLoginCallback from './OktaLoginCallback';
import {SecureRoute} from './SecureRoute';

import CountrySelection from '../CountrySelection/CountrySelection';
import LandingPage from '../LandingPage/LandingPage';
import Oops from '../oops/Oops';
import SignOut from '../signOut/signOut';

import React from 'react';
import {Routes, Route} from 'react-router-dom';

const AppRoutes = (props) => {
  return (
    <Routes>
      <Route path="/" element={<SecureRoute />}>
        <Route path="" element={<LandingPage oktaAuth={props.oktaAuth} />} />
      </Route>
      <Route path="/countrySelection" element={<CountrySelection />} />
      <Route path="/signOut" element={<SignOut oktaAuth={props.oktaAuth} />} />
      <Route path="/oktalogin" element={<OktaLoginCallback />} />
      <Route path="/oops" element={<Oops />} />
    </Routes>
  );
};

export default AppRoutes;
